import cleverooLogo from '../assets/cleveroo-logo.svg';

/** Primary app logo (bundled asset). Single source of truth for the brand mark. */
export const APP_LOGO_URL = cleverooLogo;
